import { createRequest } from "helpers/tools";

export const reconnectDestination = async (id, data) => {
    return await createRequest({
        suffix: `destinations/reconnect/${id}`,
        method: "post",
        payload: data,
        handleError: false,
    });
};
